import {createSvgIcon} from '../create-svg-icon';

export const TripOriginIcon = createSvgIcon(
  <path d="M2 12C2 6.48 6.48 2 12 2s10 4.48 10 10-4.48 10-10 10S2 17.52 2 12zm10 6c3.31 0 6-2.69 6-6s-2.69-6-6-6-6 2.69-6 6 2.69 6 6 6z" />
, 'TripOriginOutlined');
